const HomePage = () => import('@/home/pages/home.vue');

export const homeRoutes = [
  {
    path: '',
    name: 'home',
    component: HomePage,
  },
];
